import { createAction } from '@reduxjs/toolkit';

const logout = createAction('core/logout');
/** Ends the session and resets every slice, as a logout does (e.g. after changing your password). */
const timeout = createAction('core/timeout');
/**
 * The API answered 401 to a logged-in user. Only the auth slice listens: the page stays mounted
 * with its data and unsaved input while the user logs back in (`SessionExpiredDialog`).
 */
const sessionExpired = createAction('core/sessionExpired');
const resetEntities = createAction('core/resetEntities');

export { logout, timeout, sessionExpired, resetEntities };
